import { Badge } from "@/components/ui/badge";
import { STATUS_LABEL, type OrderStatus } from "@/lib/admin-orders-shared";

const TONES: Record<OrderStatus, React.ComponentProps<typeof Badge>["tone"]> = {
  PENDING: "warning",
  IN_PROGRESS: "info",
  IN_REVIEW: "violet",
  REVISIONS_PENDING: "warning",
  COMPLETED: "success",
  CANCELLED: "danger",
};

export function StatusPill({ status, className }: { status: OrderStatus; className?: string }) {
  return (
    <Badge tone={TONES[status]} className={className}>
      {STATUS_LABEL[status]}
    </Badge>
  );
}
